
import axios from 'axios';
import { getCookie } from './cookiejs'
import Vue from 'vue'
import router from '../router/index'

/*import { Message } from 'element-ui';*/

/*
axios.defaults.timeout = 5000;
axios.defaults.baseURL ='';
*/
axios.defaults.timeout = 50000;


//http request 拦截器 通过这个，我们就可以把Cookie传到后台
axios.interceptors.request.use(
  config => {
    //在发送请求之前做某事
    //const token = getCookie('JWT-TOKEN');//获取Cookie 'JWT-TOKEN'
    const token = getCookie('X-BY-EnTOKEN');//获取Cookie 'JWT-TOKEN'
    // if(!token){
    //   router.push('/reg/login');
    // }
    //console.log('X-BY-EnTOKEN  '  +   token );
    //config.data = JSON.stringify(config.data);
    config.headers['X-JWT-TOKEN'] = token;
    //if(token){
    //config.params = {}//后台接收的参数，
    //}
    //alert('token  :  ' +token)

    return config;
  },
  err => {
    //console.log("error==",err);
    if (err.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
      Toast('请求超时，请稍后再试')
      return Promise.reject(err);          // reject这个错误信息
    }
    return Promise.reject(err);
  }
);


//http response 拦截器

axios.interceptors.response.use(
  response => {
    if (response.data.ErrorCode == '401') {
      // window.location.href =Vue.prototype.$apiEn+'reg/login?ReturnUrl='+ escape(window.location.href);
      // //判断当前的路由是否是目标路由
      // if(router.currentRoute.name == "target"){
      //   //跳转回login路由，并把目标路由的url路径保存在login的query中
      //
      //   router.replace({
      //    // name:"login",
      //     query: {redirect: router.currentRoute.fullPath}
      //   })
      // }else{
      //   /* 普通401拦截直接返回到登录页面 */
      //   //router.push('/login');
      //   window.location.href =Vue.prototype.$apiAll+'CSTCenter/Login.htm';
      // }

      // window.location.href =Vue.prototype.$apiAll+'CSTCenter/Login.htm?ResultUrl='+'';
      //
      // console.log('nihap22222:'+JSON.stringify(response.data.ErrorCode));
      // router.push({
      //   //path:this.$apiAll+"CSTCenter/Login.htm",
      //   querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      //
      //
      // })
      // console.log('nihap2:'+JSON.stringify(querry));
    } else if (response.data.ErrorCode == '6101' || response.data.ErrorCode == '6103') {
      //window.location.href =Vue.prototype.$apiAll+'CSTCenter/Verified.aspx';
    } else if (response.data.ErrorCode == '6102') {
      // window.location.href =Vue.prototype.$apiAll+'CSTCenter/CertificationReview.aspx';
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}) {

  return new Promise((resolve, reject) => {
    axios.get(url, { params: params, })
      .then(response => {
        resolve(response.data);

      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);

      }, err => {
        reject(err)

      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function Del(url, params = {}) {
  console.log('that.api.param' + JSON.stringify(params))

  return new Promise((resolve, reject) => {
    axios.delete(url, { data: params })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 文件流下载
 * @param method
 * @param url
 * @param data
 * @returns {Promise}
*/
export function fileDownload(method, url, params = {}) {
  return new Promise((resolve, reject) => {
    let axiosRequestParams = {
      method,
      url,
      responseType: 'arraybuffer', // 告诉axios请求的是二进制数据流
      data: params, // post
      params: params // get
    }
    let value = method.toLowerCase() == 'post' ? 'params' : 'data';
    delete axiosRequestParams[value];
    axios(axiosRequestParams).then(response => {
      resolve(response);
    }, err => {
      reject(err);
    });
  });
}







// WEBPACK FOOTER //
// ./src/ask/axios.js